import { render, staticRenderFns } from "./page-create-nature-sound-mix.vue?vue&type=template&id=46f9896f&"
import script from "./page-create-nature-sound-mix.vue?vue&type=script&lang=ts&"
export * from "./page-create-nature-sound-mix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports